import React, {useState, useEffect} from 'react';
import {VideoEditorText} from '../VideoEditorText';
import {appText} from '../../../assets/text/appText';
import Button from '../../../uiToolkit/Buttons/Button';
import LoadingSpinner from '../../../uiToolkit/LoadingSpinner/LoadingSpinner';
import styles from './EditNarrationModal.module.css';

interface Props {
  shown: boolean;
  initialText: string;
  onSave: (text: string) => void;
  onCancel: () => void;
  isLoading?: boolean;
  isTextLoading?: boolean;
}

const EditNarrationModal = React.memo(
  ({shown, initialText, onSave, onCancel, isLoading, isTextLoading}: Props) => {
    const [text, setText] = useState(initialText);

    useEffect(() => {
      setText(initialText);
    }, [initialText, shown]);

    const hasChanges = text !== initialText;

    const handleSave = () => {
      if (hasChanges) {
        onSave(text);
      }
    };

    if (!shown) return null;

    return (
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <h2 className={styles.title}>
            {VideoEditorText.editNarrationModalTitle}
          </h2>
          {isTextLoading ? (
            <div className={styles.loadingContainer}>
              <LoadingSpinner size={40} />
            </div>
          ) : (
            <textarea
              className={styles.textarea}
              value={text}
              onChange={e => setText(e.target.value)}
              placeholder="Enter narration text..."
              disabled={isLoading}
            />
          )}
          <div className={styles.buttons}>
            <Button
              title={appText.cancel}
              onClick={onCancel}
              uiType="text"
              disabled={isLoading}
            />
            <Button
              title={VideoEditorText.editNarrationModalSave}
              onClick={handleSave}
              uiType="action"
              disabled={!hasChanges || isLoading || isTextLoading}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    );
  },
);

export default EditNarrationModal;
